function transCycle(cycle) {
    switch (cycle) {
      case "QD":
        return "每日一次";
        break;
      case "BID":
        return "每日两次";
        break;
      case "TID":
        return "每日三次";
        break;
      case "QID":
        return "每日四次";
        break;
      case "QOD":
        return "隔日一次";
        break;
      case "QW":
        return "每周一次";
        break;
      case "BIW":
        return "每周两次";
        break;
      case "TIW":
        return "每周三次";
        break;
      case "QOW":
        return "隔周一次";
        break;
      case "2W":
        return "每两周一次";
        break;
      case "3W":
        return "每三周一次";
        break;
      case "4W":
        return "每四周一次";
        break;
      case "Q1/2H":
        return "每半小时一次";
        break;
      case "QH":
        return "每小时一次";
        break;
      case "Q2H":
        return "两小时一次";
        break;
      case "Q3H":
        return "三小时一次";
        break;
      case "Q4H":
        return "四小时一次";
        break;
      case "Q6H":
        return "六小时一次";
        break;
      case "Q8H":
        return "八小时一次";
        break;
      case "Q12H":
        return "12小时一次";
        break;
      case "week_1":
        return "每周一次";
        break;
      case "month_1_2":
        return "每半个月一次";
        break;
      case "month_1":
        return "每月一次";
        break;
      case "month_2":
        return "每两个月一次";
        break;
      case "month_3":
        return "每三个月一次";
        break;
      case "month_4":
        return "每四个月一次";
        break;
      case "month_5":
        return "每五个月一次";
        break;
      case "month_6":
        return "每半年一次";
        break;
      case "year_1":
        return "每年一次";
        break;
    }
  }
  export {
    transCycle
  }